<template>
  <el-dialog :title="mode==='edit'?$t('COMMON_EDIT'):$t('COMMON_ADD_ITEM')"
             visible
             width="45%"
             @close="onCancel">

    <el-form :model="ruleForm"
             :rules="rules"
             ref="ruleForm"
             label-width="90px"
             class="demo-ruleForm">
      <el-form-item :label="$t('MASTER_DATA_TABLE_HEADER_ITEM_SUBJECT')"
                    prop="itemSubject">
        <el-input v-model="ruleForm.itemSubject"
                  maxlength="100"
                  :disabled="mode==='edit'"></el-input>
      </el-form-item>

      <transition-group name="list-complete"
                        tag="div">

        <el-row v-for="(item,index) in ruleForm.valueList"
                class="list-complete-item"
                :key="item.uid">

          <el-col :span="8">
            <el-form-item :prop="'valueList.' + index + '.itemValue'"
                          :rules="rules.valueName"
                          :label="$t('MASTER_DATA_ADD_KEY')"
                          label-width="90px">
              <el-input v-model="item.itemValue"
                        maxlength="100"
                        clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :prop="'valueList.' + index + '.itemName'"
                          :rules="rules.keyName"
                          :label="$t('MASTER_DATA_ADD_VALUE')">
              <el-input v-model="item.itemName"
                        maxlength="100"
                        clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4"
                  class="wl-icon-row">
            <i class="el-icon-arrow-down"
               @click="down(item)"></i>
            <i class="el-icon-arrow-up"
               @click="up(item)"></i>
            <i class="el-icon-delete"
               @click="deleteItem(item)"></i>
          </el-col>
        </el-row>

      </transition-group>

      <div class="wl-add-container">
        <el-button class="wl-green" @click="addItem">{{$t('COMMON_ADD')}}</el-button>
      </div>

    </el-form>

    <span slot="footer"
          class="dialog-footer">
      <el-button @click="onCancel"
                 class="cancel-btn">{{$t('comment_reSet')}}</el-button>
      <el-button type="primary"
                 :loading="saveLoading"
                 @click="onConfirm"
                 class="wl-green"
                 :disabled="ruleForm.valueList.length===0">{{$t('btn_save')}}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { getUUID, UserInput } from '@/utils'
import * as _ from 'lodash'
export default {
    data() {
        return {
            ruleForm: {
                itemSubject: '',
                valueList: []
            }
        }
    },
    computed: {
        rules() {
            const rules = {
                itemSubject: [
                    { required: true, message: this.$t('FORM_VALIDATE_REQUIRED'), trigger: 'blur' },
                    {
                        pattern: UserInput.reg,
                        trigger: 'blur',
                        message: this.$t('ILLEGAL_USER_INPUT_01')
                    }
                ],
                keyName: [
                    { required: true, message: this.$t('FORM_VALIDATE_REQUIRED'), trigger: 'blur' },
                    {
                        pattern: UserInput.reg,
                        trigger: 'blur',
                        message: this.$t('ILLEGAL_USER_INPUT_01')
                    }
                ],
                valueName: [
                    { required: true, message: this.$t('FORM_VALIDATE_REQUIRED'), trigger: 'blur' },
                    {
                        pattern: UserInput.reg,
                        trigger: 'blur',
                        message: this.$t('ILLEGAL_USER_INPUT_01')
                    },
                    { validator: this.validateUnique, trigger: 'blur' }
                ]
            }
            return rules
        }
    },
    mounted() {
        if (!_.isEmpty(this.data)) {
            const _ruleForm = {
                itemSubject: this.data.itemSubject,
                valueList: _.map(this.data.valueList, v => Object.assign({}, v, { uid: getUUID() }))
            }

            this.ruleForm = _ruleForm
        }
    },
    methods: {
        validateUnique(rule, value, callback) {
            const sum = this.ruleForm.valueList.reduce((prev, curr) => {
                return curr.itemValue.trim() === value.trim() ? prev + 1 : prev
            }, 0)
            if (sum > 1) {
                callback(new Error(this.$t('FORM_VALIDATE_DUPLICATE_KEY')))
            } else {
                callback()
            }
        },
        onConfirm() {
            this.$refs.ruleForm.validate(validate => {
                if (validate) {
                    this.onAddOrEdit(this.ruleForm)
                }
            })
        },
        up(v1) {
            const index = _.findIndex(this.ruleForm.valueList, v => v.uid === v1.uid)
            if (index === 0) return
            const list = _.cloneDeep(this.ruleForm.valueList),
                curr = _.cloneDeep(this.ruleForm.valueList[index]),
                prev = _.cloneDeep(this.ruleForm.valueList[index - 1])

            list[index] = prev
            list[index - 1] = curr

            this.ruleForm.valueList = list
        },
        down(v1) {
            const index = _.findIndex(this.ruleForm.valueList, v => v.uid === v1.uid)
            if (index === this.ruleForm.valueList.length - 1) return
            const list = _.cloneDeep(this.ruleForm.valueList),
                curr = _.cloneDeep(this.ruleForm.valueList[index]),
                next = _.cloneDeep(this.ruleForm.valueList[index + 1])

            list[index] = next
            list[index + 1] = curr

            this.ruleForm.valueList = list
        },
        addItem() {
            this.ruleForm.valueList.push({
                uid: getUUID(),
                itemName: '',
                itemValue: ''
            })
        },
        deleteItem(item) {
            this.ruleForm.valueList = _.filter(this.ruleForm.valueList, v => v.uid !== item.uid)
            this.$refs.ruleForm.validate()
        }
    },
    props: {
        onAddOrEdit: Function,
        onCancel: Function,
        data: Object,
        mode: String,
        saveLoading: Boolean
    }
}
</script>
<style scoped>
.wl-m-select {
    width: 100%;
}
.wl-icon-row {
    height: 32px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    font-size: 20px;
}
.wl-icon-row > i {
    padding: 4px;
    border-radius: 50%;
    color: #3879eb;
}
  .wl-icon-row > .el-icon-delete {
    color: #fd349c;
  }
.wl-icon-row > i:hover {
    background: #eee;
    cursor: pointer;
}

.list-complete-item {
    transition: all 0.4s;
    display: inline-block;
}
.list-complete-enter, .list-complete-leave-to{
    opacity: 0;
}
.list-complete-leave-active {
    position: absolute;
}

.el-row:first-child .el-icon-arrow-up {
    cursor: not-allowed;
    background: transparent;
    color: #a9acaf;
}
.el-row:last-child .el-icon-arrow-down {
    cursor: not-allowed;
    background: transparent;
    color: #a9acaf;
}
.wl-add-container {
    text-align: right;
}
</style>
